import "./BaknayLogo.css";
import { useIsDarkTheme } from "../../business/hooks/useIsDarkTheme";

function classNames(...parts) {
  return parts.filter(Boolean).join(" ");
}

export default function BaknayLogo({
  as: Component = "span",
  className = "",
  variant = "auto",
  size = "md",
  ...rest
}) {
  const isDark = useIsDarkTheme();
  const resolvedVariant =
    variant === "auto" ? (isDark ? "dark" : "light") : variant;
  const logoSrc = resolvedVariant === "dark" ? "/logo350_light.png" : "/logo350_dark2.png" ;

  const rootClass = classNames(
    "baknay-logo",
    `baknay-logo--${resolvedVariant}`,
    `baknay-logo--${size}`,
    className
  );

  return (
    <Component className={rootClass} {...rest}>
      <img
        src={logoSrc}
        alt="Baknay"
        className="baknay-logo__image"
        draggable="false"
      />
    </Component>
  );
}
